import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import urlJoin from 'url-join';
import { NavLink, withRouter } from 'react-router-dom';


class SectionNav extends Component {
  constructor (props) {
    super(props);
    this.state = {
      menuIsOpen: false,
      items: [],
    };
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    const { section } = nextProps;
    return { items: section.items.filter(({ inSectionNav }) => inSectionNav) };
  }

  toggleMenu () {
    this.setState({ menuIsOpen: !this.state.menuIsOpen });
  }

  renderDefaultUI () {
    const { ui, section, baseUrl } = this.props;
    const { items } = this.state;
    const firstItemId = section.items[0].uid;

    return (
      <nav className="section-subnav">
        {items.map(({ urlSlug, uid, name, linkText }, i) => {
          const url = uid === firstItemId ? baseUrl : urlJoin(baseUrl, urlSlug);
          return (
            <Fragment key={urlSlug}>
              <NavLink to={url} isActive={() => ui.activeTitle === uid}>{linkText || name}</NavLink>
              {items.length !== i + 1 ? <div className="pipe" /> : null}
            </Fragment>
          );
        })}
      </nav>
    );
  }

  renderMobileUI () {
    const { ui, section, baseUrl, activeItem } = this.props;
    const { items, menuIsOpen } = this.state;
    const inactiveItems = items.filter(({ urlSlug }) => urlSlug !== activeItem.urlSlug);
    const firstItemId = section.items[0].uid;
    const activeItemUrl = activeItem.uid === firstItemId ? baseUrl : urlJoin(baseUrl, activeItem.urlSlug);

    const classes = classNames({
      'timeline-eras-menu': true,
      open: menuIsOpen,
    });

    return (
      <nav className={classes} onClick={this.toggleMenu}>
        <div className="toggle" />
        {menuIsOpen ? (
          <NavLink to={activeItemUrl} isActive={() => ui.activeTitle === activeItem.uid}>
            <h6 className="m-0">{activeItem.linkText || activeItem.name}</h6>
          </NavLink>
        ) : (
          <h6 className="m-0">{activeItem.linkText || activeItem.name}</h6>
        )}
        <div className="sub">
          {inactiveItems.map(({ uid, urlSlug, name, linkText }) => {
            const url = uid === firstItemId ? baseUrl : urlJoin(baseUrl, urlSlug);
            return (
              <NavLink key={urlSlug} to={url} isActive={() => ui.activeTitle === uid}>
                <h6 className="m-0">{linkText || name}</h6>
              </NavLink>
            );
          })}
        </div>
      </nav>
    );
  }

  render () {
    const { section, breakpoint } = this.props;
    const subNavItems = section.items.filter(({ inSectionNav }) => inSectionNav);
    if (subNavItems.length === 0) {
      return null;
    }
    return breakpoint.lessThan.lg ? this.renderMobileUI() : this.renderDefaultUI();
  }
}


SectionNav.propTypes = {
  section: PropTypes.object.isRequired,
  baseUrl: PropTypes.string,
};

const mapStateToProps = ({ breakpoint, ui }) => ({ breakpoint, ui });

export default withRouter(connect(mapStateToProps)(SectionNav));



// WEBPACK FOOTER //
// ./src/components/SectionNav.js